module.exports = __webpack_public_path__ + "img/0Q3B7497_Foamcore_MockedUp.04be16be.jpg";